module.exports = __webpack_public_path__ + "img/ki.fb21a69a.svg";